var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _line, _path10, _path11, _path12, _circle, _path13, _line2, _path14, _circle2, _circle3, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDentalSmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st0, .st1 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.81,51.67s7.02-1.59,15.18-22.88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.79,29.69s-1.13,9.97-5.21,17.22c-.91.91-2.04,3.17,1.36,1.59s16.99-10.42,20.16-14.95c1.36-.91,1.81-4.53,2.04,2.04-.23,6.57-.45,9.71-2.04,13.46-.45.36.91,1.23,3.4,0s7.93-3.72,9.97-10.29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.48,45.16s1.95,8.1,3.99,12.17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.48,61.41s1.99-3.85,5.39-2.27c2.27,1.59,3.4,4.53,1.59,10.2-.91,3.4-3.53,6.34-6.98,7.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.85,61.56s-.45-4.38-4.38-4.23c-1.36.91-5.59,3.93-2.57,12.99,1.66,4.23,2.87,5.89,6.95,6.72"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.4,56.37s6.16-2.57,9.48,0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.02,56.37s6.8-2.27,10.12.76"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.48,72.59s-2.69,13.75-5.11,17.22c-1.51,3.02-5.77,8.31-10.81,11.63-1.42,1.06-3.08,1.81-5.65,1.81h-7.55s-1.66-.6-5.36-2.57c-3.25-1.96-13.22-3.78-17.14-28.09"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.94,96.29s.93,14.36-2.84,17.23c-3.02,3.17-7.1,10.27-6.04,23.87,1.96,14.05,3.47,21.6,10.27,33.53,1.96,4.83,3.02,8.91,3.32,17.37-.15,0-.76-1.21-.76-1.21,0,0,1.06-10.12-16.31-20.09-5.44-3.93-19.18-11.33-27.34-39.42-.76-2.72-6.04-26.43,2.42-52.26,6.19-19.94,11.78-35.95,14.35-40.48,2.42-4.53,10.82-25.53,30.63-29.3,2.6-.6,17.25-4.53,26.61,5.14.76,1.51,1.96,1.81,3.47,1.66s10.12,1.21,17.22,17.37c4.23,11.33,9.52,22.81,8.61,51.36"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.52,196.22s-13.37-38.52-16.31-42.14c-4.76-.91-18.59-6.34-20.85-7.7,0,0-9.39-4.42-10.19-4.87s-2.83-2.27-2.04-4.53c.68-1.47,1.13-2.49,1.13-2.49,0,0-2.83-1.59-2.38-3.85.23-1.36,1.13-3.96,3.74-3.29-.91-.79-2.72-3.63-1.93-6,.45-1.36.91-1.93,1.81-1.93-.23-2.04-.91-4.3,1.47-6.46,1.7-.79,5.2.11,8.38.57s10.49,2.83,11.82,2.83,8.35.39,8.8-3.71c-.11-4.1.23-8.18.79-10,.91-1.81,2.49-1.93,3.4-1.59s1.7,1.13,2.15,3.29,1.13,8.84,3.51,11.78c1.93,3.29,3.29,5.66,4.19,7.02s4.76,9.18,6.34,13.93,16.31,45.2,16.31,45.2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.63,84.97s8.91-1.66,12.39,0c.91.45,2.57.6,1.36,2.95s-8.46,6.27-13.75,1.43c-.76-.45-2.33-2.48-1.13-3.7.73-.74,1.13-.68,1.13-.68Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 118.5,
    y1: 119.41,
    x2: 138.44,
    y2: 124.17
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.62,127.34s12.57,3.51,17.22,4.53"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.26,134.48s11.55,5.32,17.67,6.12"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.38,100.91l.57-14.01s.91-4.53-5.1-4.98c-6,.23-22.66,0-22.66,0,0,0-4.44-.68-4.71,3.85s-1.09,27.8-1.09,27.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 128.47,
    cy: 89.79,
    r: 1.87
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.41,95.37s-.61,9.88-.61,12.6-.11,6.57,6.46,11.44"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 71.38,
    y1: 122.08,
    x2: 115.9,
    y2: 122.92
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.08,184.97s2.27-32.47,4.08-38.37,4.23-14.95,14.2-16.16c3.78-.76,6.32-1.44,6.32-1.44"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.08,
    cy: 62.41,
    r: 1.14
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 83.39,
    cy: 62.41,
    r: 1.14
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 94.66,
    y1: 65.43,
    x2: 94.66,
    y2: 75.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentalSmile);
export default __webpack_public_path__ + "static/media/dental-smile.5102b094bb36023ffe589165d9a346a6.svg";
export { ForwardRef as ReactComponent };